import {connect} from 'react-redux';
import LocationPickerMap from './LocationPickerMap';
import {notifyChangedPropertyDetail, retrieveSuburbInsightsAndUpdatePropertyDetail} from '../ducks/propertyDetail';

const mapStateToProps = ({propertyDetail}) => ({
  open: !!propertyDetail.singleLineAddress && !(propertyDetail.latitude && propertyDetail.longitude),
  singleLineAddress: propertyDetail.singleLineAddress,
});

const mapDispatchToProps = (dispatch) => ({
  onSelectLocation: (latitude, longitude, updateCorelogic) => {
    dispatch(retrieveSuburbInsightsAndUpdatePropertyDetail({latitude, longitude, isCustomLatLng: true }));
    if (updateCorelogic) {
      dispatch(notifyChangedPropertyDetail(true));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationPickerMap);